import { FC } from 'react';
import { Spinner } from 'reactstrap';

const Loading: FC = () => {
  return (
    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center', alignItems: 'center' }}>
      <Spinner color="primary" style={{ height: '3rem', width: '3rem', color: 'red !important' }}>
        Loading...
      </Spinner>
    </div>
  );
};

export { Loading };
